import { useQuery } from "@tanstack/react-query";
import { auditApi, type AuditLogFilters } from "../../api/audit";

export const auditKeys = {
  all: ["audit"] as const,
  list: (filters: AuditLogFilters) => ["audit", "list", filters] as const,
};

export const useAuditLog = (filters: AuditLogFilters) =>
  useQuery({
    queryKey: auditKeys.list(filters),
    queryFn: () => auditApi.list(filters),
    placeholderData: (prev) => prev,
  });
